import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const v = ({
  title: h,
  titleId: l,
  ...o
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...o,
    children: [
      h ? /* @__PURE__ */ e.jsx("title", { id: l, children: h }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M609.707 511.036H275.563v154.325c0 50.389 1.237 83.371 3.776 98.901 2.475 15.616 8.875 27.157 19.093 34.709 10.24 7.552 29.632 11.307 58.325 11.307h16.469v21.717H85.333v-21.717h16.555c27.307 0 46.315-3.477 56.853-10.368 10.517-6.976 17.28-17.728 20.267-32.32 2.965-14.656 4.48-48.704 4.48-102.229V351.505c0-50.965-1.515-83.84-4.48-98.624-2.987-14.763-9.301-25.003-18.88-30.677s-30.571-8.491-63.019-8.491H85.333v-21.717h287.893v21.717h-11.84c-31.083 0-51.563 2.624-61.291 7.765-9.792 5.227-16.32 14.891-19.605 29.056-3.328 14.144-4.928 47.808-4.928 100.971v126.976h334.144V351.505c0-50.965-1.451-83.84-4.288-98.624-2.837-14.763-9.067-25.003-18.645-30.677s-30.592-8.491-63.019-8.491h-17.003v-21.717h291.221v21.717h-9.429c-31.445 0-52.075 2.624-61.803 7.765-9.792 5.227-16.32 14.891-19.605 29.056-3.328 14.144-4.928 47.808-4.928 100.971v313.856c0 50.389 1.173 83.371 3.477 98.901 2.389 15.616 8.725 27.157 19.157 34.709 10.325 7.552 29.867 11.307 58.56 11.307h14.571v21.717H506.751v-21.717h22.208c27.072 0 45.888-3.477 56.405-10.368 10.56-6.976 17.216-17.728 20.053-32.32 2.837-14.656 4.288-48.704 4.288-102.229V511.036zm314.417-55.99h-66.667l29.12-22.485c37.952-29.376 55.808-47.104 55.808-82.667v-.597c0-39.893-29.781-66.688-74.133-66.688-29.867 0-50.709 9.429-69.781 31.552-3.669 4.352-5.867 10.219-5.867 15.723 0 12.928 10.133 23.04 23.04 23.04 6.592 0 12.971-2.709 17.109-7.253 11.861-12.8 20.672-17.536 32.491-17.536 16.277 0 25.984 9.365 25.984 25.045 0 16.96-10.432 28.181-35.392 48.555L796.38 450.46c-8.469 6.805-12.736 15.104-12.736 24.64 0 14.336 10.816 23.957 26.923 23.957h113.557c12.416 0 22.144-9.6 22.144-21.845 0-12.224-9.941-22.165-22.144-22.165z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = c(v);
export {
  s as default
};
